import { render, staticRenderFns } from "./ETMITrimestre.vue?vue&type=template&id=36ca6212&scoped=true"
import script from "./ETMITrimestre.vue?vue&type=script&lang=js"
export * from "./ETMITrimestre.vue?vue&type=script&lang=js"
import style0 from "./ETMITrimestre.vue?vue&type=style&index=0&id=36ca6212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca6212",
  null
  
)

export default component.exports